import { SxProps } from "@mui/system";
import { ThemeV2 } from "src/util/types";

export const comparisonImageStyle: SxProps = {
  maxHeight: { xs: "9vh", md: "18vh" },
  maxWidth: "100%",
  objectFit: "contain",
};

export const imageTextWrapper = (
  theme: ThemeV2,
  isCheckbox?: boolean,
  loadingImage?: boolean,
  layout: "stacked" | "inline" = "stacked",
  imagePosition: "before" | "after" = "after",
): SxProps => ({
  ...(isCheckbox
    ? { flexDirection: "row", gap: `${theme.tokens.spacing["6"]}px` }
    : layout === "inline"
      ? { flexDirection: "row", gap: `${theme.tokens.spacing["2"]}px` }
      : { flexDirection: "column" }),
  display: "flex",
  justifyContent: imagePosition === "before" ? "flex-start" : "center",
  alignItems: "center",
  cursor: "pointer",
  borderRadius: 0,
  position: "relative",
  ...(loadingImage ? { height: { xs: "40px", md: "55px" } } : {}),
});
/* c8 ignore start */
const checkBoxTextStyle = (
  theme: ThemeV2,
  isSelected?: boolean,
  disabled?: boolean,
) => {
  if (disabled) {
    return theme.tokens.color.text.secondary;
  } else if (isSelected) {
    return theme.tokens.color.action.primary;
  } else {
    return theme.tokens.color.text.primary;
  }
};
export const textStyle = (
  theme: ThemeV2,
  isSelected?: boolean,
  disabled?: boolean,
  sx?: SxProps,
  isCheckbox?: boolean,
): SxProps => {
  let dynamicColor;
  if (disabled) {
    dynamicColor = theme.tokens.color.text.inverse;
  } else if (isSelected) {
    dynamicColor = theme.tokens.color.action.primaryText;
  } else {
    dynamicColor = theme.tokens.color.action.primary;
  }
  if (isCheckbox) {
    return {
      color: checkBoxTextStyle(theme, isSelected, disabled),
      textAlign: "start",
    };
  }
  return {
    color: dynamicColor,
    textAlign: "center",
    width: "100%",
    marginY: 0,
    ...sx,
  };
};
export const loaderWrapper = {
  minWidth: "100px",
  height: { md: "55px", xs: "10px" },
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
/* c8 ignore end */
